<template>
  <valid-van-field
    v-model="col"
    :label="label"
    :placeholder="placeholder"
    :rules="reg"
    :readonly="readonly"
    :type="type"
    :maxlength="maxlength"
  />
</template>

<script>
// import Button from "@/components/Button.vue";
import { Field } from 'vant';
import ValidHoc from '@/components/valid';

const ValidVanField = ValidHoc(Field);
export default {
  name: 'CommonInput',
  components: {
    ValidVanField,
  },
  props: ['label', 'placeholder', 'reg', 'model', 'readonly', 'maxlength', 'type'],
  data() {
    return {};
  },
  computed: {
    col: {
      get() {
        return this.$store.state.commonForms[this.model];
      },
      set(value) {
        console.log(value);
        this.$store.commit('commonForms/updateForm', {
          [this.model]: value,
        });
      },
    },
  },
};
</script>
